import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { makeStyles } from "@mui/styles";
import Header from './Header';
import Footer from './Footer';
import HeaderBgr from '../../assets/header_bg.png';
import { loginObservable } from '../../common/observable.js';
import { InitState, LocalStorageText } from '../../contants/common.js';
import AppProvider from 'contexts/AppContext';
import { useThemeContext } from 'contexts/ThemeContext';
import Snackbar from 'components/Snackbar';
import ConfirmDialog from 'components/ConfirmDialog';

const styles = {
  headerBg: {
    maxWidth: '480px',
    width: '100%',
    position: 'fixed',
    top: 0,
  },
  borderLayout: {
    width: '100%',
    position: 'fixed',
    top: 0,
    height: '100%',
    maxWidth: '480px',
    boxShadow: '0 -3px 10px -3px #86868673',
  },
};
const useStyles = makeStyles((theme) => ({
  headerBgCus: ({ color }) => {
    return {
      width: '100%',
      position: 'fixed',
      top: 0,
      backgroundColor: color,
      height: "50%",
      WebkitMaskImage: '-webkit-gradient(linear, left top, left bottom, from(rgba(0,0,0,1)), to(rgba(0,0,0,0)))',
      maskImage: 'linear-gradient(to bottom, rgba(0,0,0,1), rgba(0,0,0,0))',
    }
  },
}));
const token = localStorage.getItem(LocalStorageText.Token);

if (!token) {
  localStorage.setItem(LocalStorageText.Token, InitState);
}

const SaleLayout = ({ children }) => {
  const token = localStorage.getItem(LocalStorageText.Token);
  const [loginSuccess, setLoginSuccess] = useState(!!token);
  const location = useLocation();
  const { mainColor, defaultColor } = useThemeContext();
  const classes = useStyles({ color: mainColor });

  useEffect(() => {
    loginObservable.subscribe((token) => {
      setLoginSuccess(token !== InitState);
    });
  });
  return (
    <AppProvider>
      <Snackbar />
      <ConfirmDialog />
      {mainColor === defaultColor ? <img src={HeaderBgr} style={styles.headerBg} /> : <div className={classes.headerBgCus} style={{ maxWidth: '480px', }}></div>}
      <div style={styles.borderLayout}></div>
      <div style={{ position: 'relative' }}>
        <Header style={{ zIndex: '-999 !important' }} loginSuccess={loginSuccess} />
        <main>{children}</main>
      </div>
      {loginSuccess && location.pathname.split('/')[1] !== 'compulsory-moto' && (
        <Footer style={{ position: 'relative' }} />
      )}
    </AppProvider>
  );
};

export default SaleLayout;
